import { createEvent, createStore, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { User, UserResponse, UsersRequest } from './types'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'

export const usersListMounted = createEvent<UsersRequest>()

export const deleteUserMounted = createEvent<{ id: string }>()

export const restoreUserMounted = createEvent<{ id: string }>()

export const getUsers = fx<void, UserResponse>({
  method: 'GET',
  url: `/user`,
})

export const deleteUser = fx<void, void>({
  method: 'DELETE',
  url: `/user/{userId}`,
})

export const restoreUser = fx<void, void>({
  method: 'PUT',
  url: `/user/restore/{userId}`,
})

export const $users = restore<User[]>(
  getUsers.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfUsers = restore(
  getUsers.doneData.map((a) => a.body.total),
  0,
)

export const $lastUserParams = createStore<UsersRequest | null>(null).on(
  usersListMounted,
  (_, params) => params,
)

sample({
  // @ts-ignore
  clock: usersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    // @ts-ignore
    query['where'] = `${JSON.stringify(newObj)}`

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'User.userGroups',
      'UserGroup.name',
      'User.createdAt',
      'User.deletedAt',
    ])

    return {
      query,
    }
  },
  target: getUsers,
})

sample({
  clock: deleteUserMounted,
  fn: ({ id }) => {
    return {
      url: `/user/${id}`,
    }
  },
  target: deleteUser,
})

sample({
  clock: restoreUserMounted,
  fn: ({ id }) => {
    return {
      url: `/user/restore/${id}`,
    }
  },
  target: restoreUser,
})

sample({
  // @ts-ignore
  clock: [deleteUser.done, restoreUser.done],
  source: $lastUserParams,
  fn: (params) => {
    if (params) {
      let { limit, page, orderBy, orderDirection, searchText } = params

      if (orderDirection === 'descend') {
        orderDirection = '-'
      } else if (orderDirection === 'ascend') {
        orderDirection = ''
      }

      let query = {
        limit,
        page,
      }

      if (orderBy) {
        // @ts-ignore
        query['order'] = orderDirection + orderBy
      }

      let newObj = {}

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`

      // @ts-ignore
      query['populate'] = JSON.stringify([
        'User.userGroups',
        'UserGroup.name',
        'User.createdAt',
        'User.deletedAt',
      ])

      return {
        query,
      }
    }
  },
  target: getUsers,
})
